import React, { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { trackUTMAndPromoCode } from 'actions/tracking'
import { dismissRecipesInBasketProgress } from 'actions/trackingKeys'
import { useIsBasketComprehensionEnabled } from 'routes/Menu/hooks/useIsBasketComprehensionEnabled'

import { useBasket } from '../../domains/basket'
import { RecipesInBasketProgressPresentation } from './RecipesInBasketProgress.presentation'
import { RecipesInBasketProgressTreatmentPresentation } from './Treatment/RecipesInBasketProgressTreatment.presentation'

type CloseTrackingFn = (maxRecipes: number, percentage: number) => void

function useTracking() {
  const { recipeCount } = useBasket()
  const dispatch = useDispatch()
  const dispatchTrackUTMAndPromoCode = useCallback<CloseTrackingFn>(
    (maxRecipes, percentage) => {
      dispatch(
        trackUTMAndPromoCode(dismissRecipesInBasketProgress, {
          num_recipes: recipeCount,
          max_recipes: maxRecipes,
          percentage_complete: percentage,
        }),
      )
    },
    [recipeCount, dispatch],
  )

  return { dispatchTrackUTMAndPromoCode, recipeCount }
}

const RecipesInBasketProgress = () => {
  const { dispatchTrackUTMAndPromoCode, recipeCount } = useTracking()
  const isBasketComprehensionEnabled = useIsBasketComprehensionEnabled()

  if (isBasketComprehensionEnabled) {
    return (
      <RecipesInBasketProgressTreatmentPresentation
        selectedRecipesCount={recipeCount}
        onClose={dispatchTrackUTMAndPromoCode}
      />
    )
  }

  return (
    <RecipesInBasketProgressPresentation
      selectedRecipesCount={recipeCount}
      onClose={dispatchTrackUTMAndPromoCode}
    />
  )
}

export { RecipesInBasketProgress }
